import { createFelaRenderer } from '@fluentui/react-northstar-fela-renderer';
import * as React from 'react';
export var RendererContext = /*#__PURE__*/React.createContext(createFelaRenderer());
//# sourceMappingURL=RendererContext.js.map
